"use client"

/* eslint-disable functional/immutable-data -- Only toggles the wrapper's data attribute. */
import { type ReactNode, useEffect, useRef } from "react"

/**
 * 子要素を `data-built` で「組み上げ前 → 組み上げ後」に切り替える。
 * JS なし・動きの軽減時は最初から組み上がった状態のまま。
 */
export function BuildOnView({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = ref.current
    if (
      !element ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    )
      return
    element.dataset.built = "false"
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return
        element.dataset.built = "true"
        observer.disconnect()
      },
      { threshold: 0.6 },
    )
    // 組み上げ前の状態を一度描いてから監視を始め、画面内でも落下が見えるようにする
    const frame = requestAnimationFrame(() => observer.observe(element))
    return () => {
      cancelAnimationFrame(frame)
      observer.disconnect()
    }
  }, [])

  return (
    <div ref={ref} className={className} data-built="true">
      {children}
    </div>
  )
}
